<template>
  <v-row justify="center">
    <v-col cols="2" align-self="center">
      <img height="115px" src="../../../../assets/img/quicklotto/logo.png" />
    </v-col>
    <v-col id="main-content" cols="10" class="p-0">
      <v-row justify="center" align="stretch">
        <v-col
          md="4"
          class="d-flex order-0 order-md-0 flex-column"
          v-if="results.entries.slice(1).length > 0"
        >
          <div class="card-header"><span>Winning</span> <span>Numbers</span></div>
          <result-display
            v-for="result in results.entries.slice(1)"
            :key="result.sortition.id"
            :result="result"
          >
          </result-display>
        </v-col>
        <v-col cols="12" md="4" class="d-flex order-1 order-md-1 flex-column">
          <upcoming-sortition
            id="upcoming-result"
            :upcoming-sortition="upcomingSortition"
            @refresh="fetchUpcomingSortition"
          ></upcoming-sortition>
          <div class="card-header"><span>Winning Numbers</span></div>
          <result-display
            v-for="result in results.entries.slice(0, 1)"
            :key="result.sortition.id"
            :result="result"
          >
          </result-display>
          <br />
        </v-col>
        <v-col md="4" class="d-flex order-2 order-md-2 flex-column">
          <!-- Playouts card -->
          <div class="card-header">
            <span v-if="showPrizes">
            Payouts
            </span>
						<span v-else>
							Results
						</span>
          </div>
					<prizes-card
						v-if="showPrizes"
						:prizes="prizes"></prizes-card>
					<results-card
						class="card-results"
						v-if="showResults"
						:results-by-lottery="resultsToShow"></results-card>
        </v-col>
      </v-row>
    </v-col>
    <v-col id="page-url" cols="12" class="text-center p-0">
      <span>Visit our page {{ url }}</span>
    </v-col>
  </v-row>
</template>

<script>
import ResultDisplay from "./ResultDisplay.vue";
import UpcomingSortition from "./UpcomingSortition.vue";
import BaseBoard from "../BaseBoard.js";
import PrizesCard from "./PrizesCard.vue";
import ResultsCard from '../../common/ResultsCard.vue';

export default {
  name: "Board",
  extends: BaseBoard,
  components: {
		ResultsCard,
    UpcomingSortition,
    ResultDisplay,
    PrizesCard
  }
};
</script>

<style scoped lang="scss">
@import "css/variables";
/*@import "css/main";*/
.result-display {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.v-card {
  background-color: #3b3b3b;
  color: white;
  border-radius: 30px;

  &:not(#primary-card) {
    box-shadow: 8px 6px 20px 0 #07000080;
  }
}

::v-deep .v-card #countdown {
  line-height: 60px;
  text-align: center;
  font-family: "JackFrost", serif;
}

#winning-numbers-text {
  line-height: 30px;
  color: $font-color;
}

#upcoming-sortition {
  margin-top: 15px;
  margin-bottom: 15px;
}

.card-header {
  color: $font-color;
  font-size: 1.7rem;
  padding: 0 6px;
  margin-bottom: 10px;
  margin-left: 20px;
  margin-right: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.p-0 {
  padding: 0;
}

#page-url span {
  font-size: 2rem;
  color: $font-color;
}

#main-content {
  border-top: #169b39 solid 2px;
  border-left: #169b39 solid 2px;
  border-bottom: #169b39 solid 2px;
}

::v-deep .card-results * {
	color: $font-color;
}
</style>
